export default "/institutions/td-bank.svg";